import { createVNode, render } from 'vue'
import AtToast from './index.vue'

export interface ToastParamsType {
  duration?: number
  textColor?: string
  bgColor?: string
}

type ToastTypes = 'info' | 'success' | 'error'

interface IContent {
  title: string
  roleName: string
  roleId: string
  serverName: string
}

const ShowToast = function (data: IContent, type: ToastTypes = 'info', duration = 2000) {
  const params = {
    info: { textColor: '#fff', bgColor: 'rgba(0,0,0,.8)' },
    success: { textColor: '#fff', bgColor: '#67c23a' },
    error: { textColor: '#fff', bgColor: '#f56c6c' }
  }
  createToast(data, {
    ...params[type],
    duration
  })
}
const closeToast = (div: HTMLDivElement, duration: number) => {
  setTimeout(() => {
    document.body.removeChild(div)
  }, duration)
}

const createToast = (data: IContent, params?: ToastParamsType) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const NODE = createVNode(AtToast, {
    ...data,
    ...params
  })
  render(NODE, div)
  closeToast(div, params?.duration || 2000)
}
export { ShowToast }
